import { useTranslation } from 'react-i18next';
import { useRetrieveByEventNumber } from '../../store/event/eventActions';
import { getAttributeValue, Event } from '../../interfaces/sports';
import { usePredictorStore } from 'store/predictor/predictorStore';
import './EventInformation.scss';
import { isAusGame } from 'store/options/optionsStore';
import { formatStartTime } from 'theme/formatting';

interface EventInformationProps {
  eventNumber: number;
}

const ParsedAttributes = ({ event, countryCode }: { event?: Event; countryCode?: string }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  if (!event) return null;
  const { attributes } = event;
  const raceComment = getAttributeValue({ attributes, name: 'raceComment' });
  const raceClass = getAttributeValue({ attributes, name: 'raceClass' });
  const raceGrade = getAttributeValue({ attributes, name: 'raceGrade' });
  const raceDistance = getAttributeValue({ attributes, name: 'raceDistance' });

  const classText = raceClass ? `${t('class')} ${raceClass}` : undefined;
  const gradeText = raceGrade ? `${t('grade')} ${raceGrade}` : undefined;

  if (isAusGame(countryCode)) {
    const startTime = formatStartTime(event.eventStartTime, language);
    return (
      <>
        <span className={'event-information__attribute__text'}>{startTime}</span>
        <span className={'event-information__attribute__text'}>{raceDistance}</span>
      </>
    );
  }

  const gradeClass = classText || gradeText;
  return (
    <>
      <span className={'event-information__attribute__text'}>{raceComment}</span>
      <span className={'event-information__attribute__text'}>{gradeClass}</span>
      <span className={'event-information__attribute__text'}>{raceDistance}</span>
    </>
  );
};

const EventInformation = ({ eventNumber }: EventInformationProps) => {
  const { t } = useTranslation();
  const countryCode = usePredictorStore((s) => s.activePredictor?.countryCode) ?? undefined;
  const event = useRetrieveByEventNumber(eventNumber);
  return (
    <div className={'event-information'}>
      <div className={'event-information__name'}>
        {event?.eventName}
        &nbsp; &nbsp;
        {event?.eventActive === false && <span className={'event-information__abandoned'}>{t('abandoned')}</span>}
      </div>
      <div className={'event-information__attribute'}>
        <ParsedAttributes event={event} countryCode={countryCode} />
      </div>
    </div>
  );
};
export default EventInformation;
